{
  "type": "object",
  "name": "List",
  "class": "g gtr-5 gtc-12",
  "definitions": [
    {
      "type": "container",
      "title": "Belegdaten",
      "definitions": [
        {
          "type": "date",
          "name": "belegdatum",
          "class": "color-light"
        },
        {
          "type": "string",
          "name": "bezugsnummer",
          "class": "font-bold text-lg"
        },
        {
          "type": "fieldOk",
          "name": "ktostammUrsache",
          "format": "{{number}} - {{name}}",
          "fieldOk": "ktostamm.lieferant",
          "class": ""
        },
        {
          "type": "string",
          "name": "belegnummer",
          "class": ""
        }
      ]
    },
    {
      "type": "icon",
      "name": "icon",
      "icon": "fa-regular fa-lock",
      "title": "Sperre",
      "class": "",
      "visible": {
        "name": "property",
        "property": "kzgesperrt",
        "rule": {
          "name": "boolean",
          "value": true
        }
      }
    },
    {
      "type": "date",
      "name": "faelldatum",
      "title": "Fälligkeit",
      "class": ""
    },
    {
      "type": "fieldOk",
      "name": "ktostammBaustelle",
      "title": "Kostenstelle",
      "format": "{{number}} - {{name}}",
      "fieldOk": "ktostamm.kunde.subnummer",
      "class": ""
    },
    {
      "type": "text",
      "text": "EUR"
    },
    {
      "type": "number",
      "name": "saldo",
      "title": "Wert",
      "format": "1.2-2",
      "class": ""
    }
  ]
}
